import { Chip } from '@mui/material';
import { formatters } from '@utils/formattersV2';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export type AdSpendChipProps = {
  adSpend: number | null;
};

export const AdSpendChip = (props: AdSpendChipProps) => {
  return (
    <Chip
      label={`Ad Spend ${formatters.currency(props.adSpend)}`}
      size="small"
      sx={{
        color: unifiedPlatformColorPalette.lightTextSecondary,
        px: '0.25rem',
        fontWeight: 500,
      }}
    />
  );
};
